import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const CreateItemPopupSaveButton = ({ itemCreateService, successRedirectTo }) => {
    const { i18n } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();    
    
    const redirectToEditPage = (response) => {
        if(response && response.id) {
            navigate(`${successRedirectTo}/${response.id}`);
        } else {
            itemCreateService.changeItemCode('');
        }
    };

    const createNewItem = () => {
        if(!isDisabled) {
            itemCreateService.saveNewItem(redirectToEditPage);
        }
    };

    const changeButtonState = () => {
        setIsDisabled(itemCreateService.checkCodeValidation() !== '');
    };

    useEffect(() => {
        itemCreateService.registerObserver(changeButtonState);
        return () => itemCreateService.unRegisterObserver(changeButtonState);
    }, []);

    return (
        <Button disabled={isDisabled} onClick={createNewItem}>
            {i18n.t(`app.page.product.modal.create`)}
        </Button>
    );
};

export default CreateItemPopupSaveButton;
